module.exports = __webpack_public_path__ + "img/01.600f080b.jpg";